import "../Css/Certifications.css";
import { getLogo, getOrganization } from "../AppMethods";

const certifications = [
    { name: "Databases: Relational Databases and SQL", issuer: "Stanford Online", date: "10/2025", url: "https://courses.edx.org/certificates/d4cd7264a9de49938fae352b81799dd0"},
    { name: "The Complete Agentic AI Engineering Course (2025)", issuer: "Udemy", date: "08/2025", url: "https://ude.my/UC-6cbac3f8-a21b-482a-8a5c-af7b2a4b4860"},
    { name: "Special Forces Training - Corporal Promotion", issuer: "Greek Army, Nea Peramos", date: "06/2024", url: "https://drive.google.com/file/d/1ovGMwV10OmSx74mo-WrzofbHsJXnB7sc/view?usp=sharing" },
    { name: "Special Forces Training - Excellence Award (2nd in Unit)", issuer: "Greek Army, Naousa", date: "02/2024", url: "https://drive.google.com/file/d/1AZPc4diVeBmLCVxsz0tZ_Hxbatmxroby/view?usp=sharing" },
    { name: "Professional Scrum Product Owner I", issuer: "Scrum.org", date: "06/2023", url: "https://drive.google.com/file/d/1QdHi3RjvE92qE2PbBBfpr22yZfoE8yUn/view?usp=sharing" },
    { name: "The Fundamental Principles of Diplomatic Practice", issuer: "Hellenic Institute of Cultural Diplomacy", date: "09/2022", url: "https://drive.google.com/file/d/1ZC0qI77rIjbExQlrAwVisnIl__cje56m/view?usp=sharing" },
    { name: "ISTQB - Foundation Level", issuer: "ISTQB", date: "03/2022", url: "https://drive.google.com/file/d/1_5kYlnxYFfhy-I2q8D1dTBNVbw5NUfGh/view?usp=sharing" },
    { name: "Deloitte's SAP ABAP Academy", issuer: "Deloitte", date: "01/2020", url: "https://drive.google.com/file/d/1lTuKWxjsx8eZ9bvYEa0gS__vVbxDtS6q/view?usp=sharing" },
];

const Certifications = () => {

    return (

        <section className="mb-3" id="certifications">

            <h2 className="section-title">
                <i className="fas fa-award"></i><span style={{ marginLeft: "10px" }}>Certifications</span>
            </h2>

            <div className="certifications-container cv-grid">

                {

                    certifications.map((cert, index) => (

                        <div key={index} className="certification-card cv-card">
                            
                            <h5 
                                onClick={() => cert.url && cert.url !== "#" && window.open(cert.url, "_blank")} 
                                onAuxClick={(e) => {
                                    if (e.button === 1 && cert.url && cert.url !== "#") {
                                        e.preventDefault();
                                        const newWindow = window.open(cert.url, "_blank");
                                        if (newWindow) {
                                            newWindow.blur();
                                            window.focus();
                                        }
                                    }
                                }}
                                onMouseDown={(e) => {
                                    if (e.button === 1 && cert.url && cert.url !== "#") {
                                        e.preventDefault();
                                    }
                                }}
                                style={{ cursor: cert.url && cert.url !== "#" ? "pointer" : "default" }}
                            >

                                <img src={getLogo(getOrganization(cert.issuer))} alt="organization-logo" className="organization-logo" />

                                <span className="certification-text">
                                    <span className="certification-name">{cert.name}</span>
                                    <span className="certification-meta">{cert.issuer} • {cert.date}</span>
                                </span>

                            </h5>

                            {/* <p>Issued {cert.date}</p> */}

                        </div>

                    ))

                }

            </div>

        </section>

    );

};

export default Certifications;